import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileInvoice,
  faLock,
  faHeadphones,
  faExchangeAlt,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import productImg from 'assets/img/products/23.png';
import { IconProp } from '@fortawesome/fontawesome-svg-core'; // ✅ Import IconProp

const Pill = ({ icon, text }: { icon: IconProp; text: string }) => (
  <div className="d-flex align-items-center gap-2 px-3 py-2 border rounded-3 bg-white w-100 h-100">
    <FontAwesomeIcon
      icon={icon}
      className="text-danger"
      style={{ fontSize: '0.9rem' }}
    />
    <span className="fw-semibold small">{text}</span>
  </div>
);

const ProductBenefitsWarranty: React.FC = () => {
  return (
    <>
      {/* Benefits */}
      <h6 className="fw-bold mb-2">TreadSouq Benefits</h6>
      <Row className="g-2 mb-3">
        <Col xs={6} md={4}>
          <Pill icon={faFileInvoice} text="GST Invoice" />
        </Col>
        <Col xs={6} md={4}>
          <Pill icon={faLock} text="Secure Payments" />
        </Col>
        <Col xs={12} md={4}>
          <Pill icon={faHeadphones} text="365-Day Help Desk" />
        </Col>
      </Row>

      {/* Warranty */}
      <h6 className="fw-bold mb-2 pt-2 border-top">Exchange &amp; Warranty</h6>
      <Row className="g-2 mb-3">
        <Col xs={12} md={4}>
          <Pill icon={faExchangeAlt} text="Only Exchange" />
        </Col>
      </Row>

      {/* Bulk-buy CTA */}
      <div className="border rounded-3 p-2 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3 bg-white">
        <img
          src={productImg}
          alt="Product"
          width={70}
          height={70}
          className="flex-shrink-0 rounded"
        />

        <div className="flex-grow-1">
          <p className="fw-bold mb-1 small">
            Looking to purchase House Wires in bulk?
          </p>
          <ul className="mb-0 list-unstyled small">
            <li className="d-flex gap-1">
              <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
              <span>Buy in bulk quantity</span>
            </li>
            <li className="d-flex gap-1">
              <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
              <span>Get best business price</span>
            </li>
          </ul>
        </div>

        {/* CTA */}
        <Button
          className="fw-semibold px-3 py-2 text-nowrap bg-white border-2 border-danger text-danger shadow-sm w-100 w-md-auto"
          style={{ transition: 'all .25s', minWidth: 180 }}
          onMouseEnter={e => {
            e.currentTarget.classList.add('bg-danger', 'text-white');
            e.currentTarget.classList.remove('bg-white', 'text-danger');
          }}
          onMouseLeave={e => {
            e.currentTarget.classList.add('bg-white', 'text-danger');
            e.currentTarget.classList.remove('bg-danger', 'text-white');
          }}
        >
          RAISE REQUEST
        </Button>
      </div>
    </>
  );
};

export default ProductBenefitsWarranty;
